'use client';

import { PropsWithChildren, useRef } from 'react';
import dynamic from 'next/dynamic';
import type { GlobalCanvasProps } from './GlobalCanvas';
import { atom, useAtomValue, useSetAtom } from 'jotai';
const GlobalCanvas = dynamic(async () => import('./GlobalCanvas'), { ssr: false });

const defaultCanvasZIndex = 10;

const canvasZIndex = atom<number>(defaultCanvasZIndex);

export const useCanvasZIndex = () => useAtomValue(canvasZIndex);
export const useSetCanvasZIndex = () => {
	const setZIndex = useSetAtom(canvasZIndex);
	return (zIndex: number) => {
		setZIndex(zIndex);
	};
};
export const useResetCanvasZIndex = () => {
	const setZIndex = useSetAtom(canvasZIndex);
	return () => {
		setZIndex(defaultCanvasZIndex);
	};
};

export function ThreeLayout({ children, ...props }: PropsWithChildren<GlobalCanvasProps>) {
	const canvasZIndex = useCanvasZIndex();
	const ref = useRef<HTMLDivElement>(null);

	const { style, ...canvasProps } = props;

	return (
		<div ref={ref} className='relative'>
			{children}
			<GlobalCanvas
				style={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100dvw',
					height: '100dvh',
					pointerEvents: 'none',
					zIndex: canvasZIndex,
					...style,
				}}
				{...canvasProps}
				eventSource={ref as React.MutableRefObject<HTMLElement>}
				eventPrefix='client'
			/>
		</div>
	);
}
